import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import formatter from "../../../../../../../../utils/formatter";
import { ExchangeFromTable, TableFlex } from './styles';
import { allocationState } from "../../../../selectors";
import { replaceSelect } from "../../../../../../../../utils/replacer";

let isLegacyTransaction = false;

function renderActiveExchangeUnit(text) {
  return formatter({
    value: text["futureAllocPercentage"],
    fieldSuffix: isLegacyTransaction ? 'Dollars' : "Percentage",
  });
}

function renderRowTitle(text) {
  return (
    <div>{ replaceSelect(text["mName"]) }</div>
  );
}

export function Allocation(props) {
  const columns = [
    {
      title: 'Investment Options',
      render: renderRowTitle,
      key: 'name',
      width: '50%',
    },
    {
      title: props.data.legacyTransaction ? 'Amount' : "Percentage",
      render: renderActiveExchangeUnit,
      key: 'activeExchangeUnit',
      width: '50%',
    },
  ];
  isLegacyTransaction = props.data.legacyTransaction;
  return (props.data ?
   (
     <TableFlex >
    <ExchangeFromTable data-test="exchange-table"
      pagination={false}
      display={props.data.legacyTransaction ? true : false}
      columns={columns}
      dataSource={props.data.investmentOption ? props.data.investmentOption : []}  
    />
    </TableFlex>
  )
  : null)
}

Allocation.propTypes = {
 data: PropTypes.array
}

const mapStateToProps = state => ({
  ...allocationState(state.toJS())
});

export default connect(
  mapStateToProps,
  null,
)(Allocation);
